<template>
  <div class="qrcode">
    <div id="reader"></div>
    <div class="close" @click="onclose">关闭</div>
  </div>
</template>
 
<script>
import { Html5Qrcode } from "html5-qrcode";
export default {
  created() {
    this.getCameras();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    getCameras() {
      Html5Qrcode.getCameras()
        .then((devices) => {
          if (devices && devices.length) {
            // this.$toast(devices);
            this.html5QrCode = new Html5Qrcode("reader");
            this.start();
          }
        })
        .catch((err) => {
          // handle err
          this.html5QrCode = new Html5Qrcode("reader");
          console.log(err);
          this.$toast("您需要授予相机访问权限");
          this.$toast(err);

          this.error = "ERROR: 您需要授予相机访问权限";
          this.$emit("err", this.error);
        });
    },
    start() {
      //environment后置 user前置
      this.html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 2,
            qrbox: { width: 250, height: 250 },
          },
          (decodedText, decodedResult) => {
            this.$emit("ok", decodedText);
            this.onclose();
          }
        )
        .catch((err) => {
          this.$emit("err", err);
        });
    },
    stop() {
      this.html5QrCode
        .stop()
        .then((ignore) => {
          // QR Code scanning is stopped.
          console.log("QR Code scanning stopped.");
        })
        .catch((err) => {
          // Stop failed, handle it.
          console.log("Unable to stop scanning.");
        });
    },
    onclose() {
      //   this.stop();
      this.$emit("onclose", false);
    },
  },
};
</script>
 
<style lang="less" scoped>
.qrcode {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(#000000, 0.48);
}
#reader {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.close {
  padding: 4px 10px;
  background-color: #3db0fc;
  color: #fff;
  position: absolute;
  top: 70%;
  left: 48%;
}
</style>